import { transparentize } from 'polished'
import styled from 'styled-components'

import { ButtonPlain } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	isDisabled: boolean
}

export const HeaderRow = styled(ButtonPlain)<Props>`
	align-items: center;
	display: flex;
	overflow-wrap: break-word;
	font-size: ${helpers.font.size.base};
	color: ${helpers.color.text};
	padding: 8px;
	gap: ${helpers.spacing.medium};

	transition: background-color 150ms ${helpers.animation.default};
	cursor: ${({ isDisabled }) => (isDisabled ? 'auto' : 'pointer')};
	border-radius: 8px;

	&:hover:not(:disabled) {
		background-color: ${({ isDisabled, theme }) => !isDisabled && transparentize(0.92, theme.color.actionHover)};
	}
`
